function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { BaseSource } from "../BaseSource.js";
import { TextStyle } from "../../textStyle.js";
import { serializeCloudinaryCharacters } from "../../../internal/utils/serializeCloudinaryCharacters.js";
import { Action } from "../../../internal/Action.js";
import { Qualifier } from "../../../internal/qualifier/Qualifier.js";
import { prepareColor } from "../../../internal/utils/prepareColor.js";
/**
 * @memberOf Qualifiers.Source
 * @extends {Qualifiers.Source.BaseSource}
 * @description Defines the common interface for all text-based sources
 */

var BaseTextSource = /*#__PURE__*/function (_BaseSource) {
  _inherits(BaseTextSource, _BaseSource);

  var _super = _createSuper(BaseTextSource);

  function BaseTextSource(text, textStyle) {
    var _this;

    _classCallCheck(this, BaseTextSource);

    _this = _super.call(this);
    _this.type = 'text';
    _this.text = text;
    _this._textStyle = textStyle;
    _this._qualifierModel.sourceType = 'text';
    _this._qualifierModel.text = text;

    if (textStyle instanceof TextStyle) {
      _this._qualifierModel.textStyle = textStyle.toJson();
    }

    return _this;
  }

  _createClass(BaseTextSource, [{
    key: "encodeText",
    value: function encodeText(text) {
      return serializeCloudinaryCharacters(text);
    }
  }, {
    key: "textColor",
    value: function textColor(color) {
      this._textColor = color;
      this._qualifierModel.textColor = color;
      return this;
    }
  }, {
    key: "backgroundColor",
    value: function backgroundColor(bgColor) {
      this._backgroundColor = bgColor;
      this._qualifierModel.backgroundColor = bgColor;
      return this;
    }
  }, {
    key: "textFit",
    value: function textFit(_textFit) {
      this._textFit = _textFit;
      return this;
    }
    /**
     * @description
     * Returns the opening string of the layer,
     * This method is used internally within {@link SDK.LayerAction|LayerAction}
     * @returns {string}
     */

  }, {
    key: "getOpenSourceString",
    value: function getOpenSourceString(layerType) {
      var layerParam = [this.type, this._textStyle && this._textStyle.toString(), this.encodeText(this.text)].filter(function (a) {
        return a;
      }).join(':');
      var tmpAction = new Action();
      tmpAction.addQualifier(new Qualifier(layerType, layerParam));
      this._textColor && tmpAction.addQualifier(new Qualifier('co', prepareColor(this._textColor)));
      this._backgroundColor && tmpAction.addQualifier(new Qualifier('b', prepareColor(this._backgroundColor)));
      this._textFit && tmpAction.addQualifier(this._textFit);
      return tmpAction.toString();
    }
  }]);

  return BaseTextSource;
}(BaseSource);

export { BaseTextSource };